import {
  PRINT_FONT_SIZE,
  cellPaddingSx,
  valueTypographySx,
} from '../printStyles';

export const summaryCellSx = {
  ...cellPaddingSx,
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
} as const;

export const summaryValueSx = {
  ...valueTypographySx,
  fontSize: PRINT_FONT_SIZE.summary,
  minWidth: 0,
} as const;
